module.exports = __webpack_public_path__ + "img/kaifa.103ccdba.png";